import React from 'react';

import { Container, Row } from './styles';
import logo from '../../assets/images/logo-zignet.png';
import { IExtractComprovanteProps } from '../../services/hooks/useComprovante';
import Moment from 'moment';
import { CnpjMask } from '../../utils/CnpjMask';
import { CpfMask } from '../../utils/CpfMask';
import BankNameEnum from '../../enums/BankNameEnum';

function StyledCardComprovante({
  sacadoBanco,
  sacadoAgencia,
  sacadoConta,
  dtTransacao,
  vlMovimento,
  meioPagamento,
  autenticacao,
  favDocto,
  favNome,
  favBanco,
  favBancoNome,
  favTipoConta,
  favAgencia,
  favConta,
}: IExtractComprovanteProps) {
  return (
    <Container id="containerComprovante">
      <header>
        <img src={logo} alt="Logo do comprovante de transferência" />
        <h2>COMPROVANTE DE TRANSFERÊNCIA</h2>
      </header>
      <body>
        <div>
          <span>Dados Pagador</span>
          <Row margin={6}>
            <td>ZIGNET SOLUC PAGAMENTOS LTDA</td>
            <p>06.540.857/0001-80</p>
          </Row>
          <Row>
            <td>{BankNameEnum[sacadoBanco as keyof typeof BankNameEnum]}</td>
            <p>{`${sacadoAgencia}/${sacadoConta}`}</p>
          </Row>
        </div>
        <div>
          <span>Dados Beneficiário</span>
          <Row margin={6}>
            <td>{favNome}</td>
            <p>
              {favDocto.length <= 12
                ? CpfMask(favDocto.padStart(11, '0'))
                : CnpjMask(favDocto.padStart(14, '0'))}
            </p>
          </Row>
          <Row>
            <td>{BankNameEnum[favBanco as keyof typeof BankNameEnum]}</td>
            <p>
              {favAgencia}/{favConta} {favTipoConta}
            </p>
          </Row>
        </div>
        <div>
          <span>Dados da Transação</span>
          <Row margin={6}>
            <td>
              Valor{' '}
              {new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
                minimumFractionDigits: 2,
              }).format(vlMovimento)}
            </td>
          </Row>
          <Row margin={6}>
            <td>Tipo: {meioPagamento}</td>
            {/* <p>
              Data de Transferência: {Moment(dtTransacao).format('DD/mm/yyyy')}
            </p> */}
          </Row>
          <Row margin={6}>
            <td>
              Autenticação: <p style={{ fontSize: '12px' }}>{autenticacao}</p>
            </td>
            {/* <p>Identificação</p> */}
          </Row>
          {/* <Row margin={6}>
            <td>ID da transação: xxxxxxxxxxxxx</td>
          </Row>
          <Row margin={6}>
            <td>Controle: xxxxxxxxxxxxx</td>
          </Row> */}
          <Row>
            <td>
              Efetuada em {Moment(dtTransacao).format('DD/MM/yyyy')} às{' '}
              {Moment(dtTransacao).format('hh:mm:ss')}
            </td>
          </Row>
        </div>
      </body>
      <footer>
        Em caso de dúvidas, entre em contato com o financeiro através dos
        telefones:
        <p>Capital de SP e Regiões: 11 5171-8484</p>
        <p>Demais Localidades: 0800 5800 094</p>
      </footer>
    </Container>
  );
}

export default StyledCardComprovante;
